module.exports = "/_next/static/images/6-de69b7139f023bf124675a2d8599c29b.png";